






































































import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class Registration extends Vue
{
    private message: string = '';

    private userName: string = '';
    private email: string = '';
    private password: string = '';
    private repeatPassword: string = '';

    private userNameError: string = '';
    private emailError: string = '';
    private passwordError: string = '';
    private repeatPasswordError: string = '';

    async onSubmit(event: any)
    {
        var data: object = {
            "email": this.email,
            "password": this.password,
            "repeatPassword": this.repeatPassword,
            "givenName": this.userName
        };
        fetch('/api/users/register',
            {
                method: 'POST',
                headers:
                {
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                },
                body: JSON.stringify(data),
            })
            .then((response) => response.json())
            .then((data) =>
            {
                if (data.errors)
                {
                    this.userNameError = '';
                    this.emailError ='';
                    this.passwordError = '';
                    this.repeatPasswordError = '';
                    if(data.errors['givenName'])
                    {
                        if (Array.isArray(data.errors['givenName']))
                        {
                            this.userNameError = data.errors['givenName'].join(", ");
                        }
                        else
                        {
                            this.userNameError = data.errors['givenName'];
                        }
                    }
                    if(data.errors['email'])
                    {
                        if (Array.isArray(data.errors['email']))
                        {
                            this.emailError = data.errors['email'].join(", ");
                        }
                        else
                        {
                            this.emailError = data.errors['email'];
                        }
                    }

                    if(data.errors['password'])
                    {
                        if (Array.isArray(data.errors['password']))
                        {
                            this.passwordError = data.errors['password'].join(", ");
                        }
                        else
                        {
                            this.passwordError = data.errors['password'];
                        }
                    }

                    if(data.errors['repeatPassword'])
                    {
                        if (Array.isArray(data.errors['repeatPassword']))
                        {
                            this.repeatPasswordError = data.errors['repeatPassword'].join(", ");
                        }
                        else
                        {
                            this.repeatPasswordError = data.errors['repeatPassword'];
                        }
                    }
                }
                else
                {
                    this.message = 'Kontoen er opprettet, i løpet av et øyeblikk blir du omdirigert til påloggingssiden.';
                    setTimeout(() =>
                    {
                        this.$router.push('login');
                    }, 5000);
                }
            })
            .catch((error) =>
            {
                console.log('Error:', error);
            });
    }
}
